import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartCameraListsComponent } from './cart-camera-lists.component';
import { CameraFormModule } from './../../forms/camera-form/camera-form.module';
import { AngularMaterialModule } from '../../angular-material/angular-material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InlineSVGModule } from "ng-inline-svg";
import { PipesModule } from "../../pipes/index";



@NgModule({
  declarations: [CartCameraListsComponent],
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule, ReactiveFormsModule,
    InlineSVGModule,
    CameraFormModule,
    PipesModule
  ],
  exports: [CartCameraListsComponent]
})
export class CartCameraListsModule { }
